// extracted by mini-css-extract-plugin
module.exports = {"option":"EIqje2","intersection":"_1Ja7Q4","image":"_1iuioQ","text":"_1uVJdc","shine-lines":"otfzBk"};